module.exports = __webpack_public_path__ + "static/img/apply1.02658e02.png";